import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://nilhosqgvmsabnljpavo.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5pbGhvc3Fndm1zYWJubGpwYXZvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ4MTczNzksImV4cCI6MjA4MDM5MzM3OX0.OCjijhy9q77bsPZxy81n2btASqUy50k2hjG9ROXLxjU';

// Cliente Supabase para o frontend
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

export default supabase;




